import * as React from 'react';
export const carnetSvg = React.forwardRef(function carnetSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#D3262B',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M16 12.162c5.922 0 10.828 2.222 11.81 5.142.116-.348.19-.704.19-1.07 0-3.43-5.372-6.21-12-6.21s-12 2.78-12 6.21c0 .366.073.722.19 1.07.98-2.92 5.888-5.141 11.81-5.141Zm0 3.696c5.922 0 10.828 2.222 11.81 5.142a3.37 3.37 0 0 0 .19-1.069c0-3.43-5.372-6.211-12-6.211S4 16.5 4 19.93c0 .366.073.722.19 1.069.98-2.92 5.888-5.142 11.81-5.142Z',
    }),
  );
});
carnetSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var carnet = {
  category: 'brand',
  colorable: false,
  name: 'carnet',
  svg: carnetSvg,
};
